module.exports = __webpack_public_path__ + "img/icon_help_home.005067a1.svg";